import styled from 'styled-components';
import { Paper } from '@material-ui/core';

// CONSTANTS
import { RADICAL_RED, PORCELAIN, WHITE, WOODSMOKE_2, KOURNIKOVA_2 } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// ASSETS
import IOBgPic from '@/assets/images/ispPartners/internet-option-bg.png';

export const Container = styled(Paper)`
  overflow: hidden;
  margin-bottom: 30px;

  .internet-option {
    &__wrap {
      position: relative;

      ${breakpoints.up('md')} {
        display: flex;
        justify-content: space-between;
      }
    }

    &__left,
    &__right {
      ${breakpoints.up('md')} {
        width: 50%;
      }
    }

    &__left {
      padding: 23px 32px;

      ${breakpoints.down('xs')} {
        padding: 32px 15px;
      }
    }

    &__right {
      display: flex;
      align-items: center;
      padding: 20px 20px 20px 60px;
      background-image: url(${IOBgPic});
      background-repeat: no-repeat;
      background-position: left center;
      background-size: cover;
    }

    &__main-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: default;
    }

    &__image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 104px;
      height: 78px;
      padding: 10px;
      border-radius: 8px;
      margin-right: 15px;
      background-color: ${PORCELAIN};

      img {
        display: block;
        max-width: 84px;
        max-height: 58px;
      }
    }

    &__description {
      margin-top: 15px;
      font-size: 1.8rem;
      line-height: 3rem;

      .markdown {
        display: inline;
        > p {
          display: inline;
        }

        small {
          font-size: 1.3rem;
          line-height: inherit;
        }

        button {
          line-height: inherit;
          vertical-align: bottom;
        }
      }

      p {
        margin-bottom: 0;
      }
    }

    &__offer-details {
      cursor: pointer;
    }

    &__actions {
      margin-top: 15px;

      ${breakpoints.down('md')} {
        margin-top: 25px;
      }

      .MuiButton-root {
        min-width: 197px;

        ${breakpoints.down('xs')} {
          width: 100%;
        }
      }

      > :not(:last-child) {
        margin-right: 8px;

        ${breakpoints.down('xs')} {
          margin-right: 0;
          margin-bottom: 12px;
        }
      }
    }
  }

  &.internet-option--collapsible {
    ${breakpoints.down('xs')} {
      margin-right: auto;
      margin-left: auto;

      .internet-option {
        &__left {
          padding: 0;

          button {
            position: relative;
            width: 100%;
            padding: 15px 20px 15px 50px;

            justify-content: flex-start;

            cursor: pointer;
          }

          i {
            position: absolute;
            top: calc(50% - 7px);
            left: 20px;
            font-size: 1.4rem;
            transform: rotate(90deg);
            transition: transform 0.4s;
          }
        }

        &__content {
          padding: 0 15px 15px;
        }
      }
    }
  }

  &.internet-option--ad {
    border-radius: 16px;

    .internet-option__ad {
      padding: 20px 15px;

      background-color: ${WOODSMOKE_2};
      color: ${WHITE};

      font-weight: 600;
      font-size: 1.4rem;
      line-height: 2.4rem;

      display: flex;
      justify-content: center;

      .ad-text {
        text-align: center;
        max-width: 508px;
        margin: 0;
      }

      b {
        color: ${KOURNIKOVA_2};
      }

      ${breakpoints.up('sm')} {
        padding: 25px 20px;
      }
    }
  }

  .view-offers-link {
    display: inline-block;
    margin-top: 15px;
    margin-left: 30px;
    line-height: 1.6rem;

    ${breakpoints.down('xs')} {
      margin-top: 25px;
      margin-left: 0;
      width: 100%;
      text-align: center;
    }

    &::after {
      font-family: 'icomoon';
      content: '\\e906';
      font-size: 1rem;
      margin-left: 5px;
    }
  }

  .benefits {
    ${breakpoints.down('md')} {
      margin-top: 20px;
    }

    ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
      color: ${WHITE};

      ${breakpoints.down('sm')} {
        color: ${p => p.theme.palette.text.primary};
      }

      li {
        position: relative;
        font-size: 2.2rem;
        line-height: 2.7rem;
        padding-left: 30px;

        ${breakpoints.down('sm')} {
          font-size: 1.6rem;
          line-height: 2.1rem;
          padding-left: 24px;
        }

        &:not(:last-of-type) {
          margin-bottom: 15px;
        }

        &:before {
          content: '\\e913';
          font-family: 'icomoon';
          position: absolute;
          top: 0;
          left: 0;
          font-size: 1.8rem;
          color: ${p => p.theme.palette.primary.main};

          ${breakpoints.down('sm')} {
            content: '\\e904';
            font-size: 1.4rem;
          }
        }
      }
    }
  }
`;

export const Price = styled.div`
  display: flex;
  align-items: flex-start;
  line-height: 1.8rem;

  .price {
    &__title {
      margin-right: 4px;
    }

    &__price {
      white-space: nowrap;
    }
  }

  .p4 {
    display: inline-block;
    line-height: 1.8rem;
  }

  .price-section {
    display: inline-block;
    line-height: 1.8rem;

    > * {
      display: inline-block;
    }

    &__old {
      position: relative;
      margin-right: 8px;

      .p4 {
        color: ${p => p.theme.palette.text.secondary};
      }

      &:before {
        content: '';
        position: absolute;
        right: -3px;
        left: -3px;
        top: 50%;
        transform: translate(0, -50%);
        height: 1px;
        background-color: ${RADICAL_RED};
      }
    }
  }
`;

export default Container;
